export const teams = [
  {
    club: "",
    id: ""
  },
  {
    club: "Broadwell Amateurs FC",
    id: "Broadwell",
    ground: "The Hawthorns, Poolway Road, Broadwell. Colford, Glos. GL16 7BE",
    groundHref:
      "https://www.google.co.uk/maps/place/Broadwell+Amateurs+FC/@51.7963459,-2.6041551,672m/data=!3m1!1e3!4m5!3m4!1s0x0:0x70d7054a547b4d07!8m2!3d51.7956912!4d-2.5994052",
    groundPhone: "01594 837097",
    badge: "../images/badges/broadwell.png",
    secretary: "Leslie Lewis",
    secretaryEmail:
      "mailto:les.lewis1955@btinternet.com?subject=Contact via the GCL web site",
    chairman: "Gary Powell",
    programEditor: "Mark Gabriel",
    programEditorEmail:
      "mailt0:gabriel.mark@sky.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Broadwell_Amateurs_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Broadwell_Amateurs_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "http://www.broadwellafc.co.uk/",
    socialWebText: "Broadwell Amateurs Football Club",
    socialTwitterHandle: "@BroadwellAFC",
    socialTwitter: "https://twitter.com/BroadwellAFC",
    socialFacebookHandle: "",
    socialFacebook: "",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Claret & Blue Shirts, Claret Shorts, Claret Socks",
    coloursHomeImage: "../images/shirts/broadwell_home_2020.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Yellow & Blue Shirts, Dark Blue Shorts, Blue Socks",
    coloursAwayImage: "../images/shirts/broadwell_away_2020.jpg",
    teamImage: "",
    statsTeam: "Broadwell Amateurs",
  },
  {
    club: "Bromley Heath United FC",
    id: "Bromley",
    ground:
      "Pomphrey Hill Playing Fields, Pomphrey Hill, Mangotsfield, BS16 9NF",
    groundHref:
      "https://www.google.com/maps/place/Pomphrey+Hill+Pavilion/@51.4804134,-2.4802712,695m/data=!3m1!1e3!4m5!3m4!1s0x48718549ad8c9065:0xe3bb074b19b5ba6c!8m2!3d51.4804134!4d-2.4780825",
    groundPhone: "0117 956 3340",
    badge: "../images/badges/bromley_heath.png",
    secretary: "Phil Britton",
    secretaryEmail:
      "mailto:philipbritton@sky.com?subject=Contact via the GCL web site",
    chairman: "Jamie Andrews-Britton",
    programEditor: "Philip Britton",
    programEditorEmail:
      "mailto:philipbritton@sky.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Bromley_Heath_United_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Bromley_Heath_United_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "https://bhufc.co.uk/",
    socialWebText: "Bromley Heath United FC",
    socialTwitterHandle: "@BromleyHeathUtd",
    socialTwitter: "https://twitter.com/BromleyHeathUtd",
    socialFacebookHandle: "Bromley Heath United Football Club",
    socialFacebook: "https://www.facebook.com/BromleyHeathFootballClub/",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Yellow & Blue Shirts, Blue Shorts, Blue Socks",
    coloursHomeImage: "",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Red Shirts, Red Shorts, Red Socks",
    coloursAwayImage: "../images/shirts/bromley_heath_away_2019.png",
    teamImage: "",
    statsTeam: "Bromley Heath United",
  },
  {
    club: "English Bicknor FC",
    id: "English",
    ground: "English Bicknor Village Hall, Ross Road, English Bicknor, Gloucestershire, GL16 7PA",
    groundHref:
      "https://www.google.com/maps/place/English+Bicknor+Football+Club/@51.8372277,-2.6231655,2763m/data=!3m1!1e3!4m9!1m2!2m1!1sgl16+7pA+ENGLISH+BICKNOR+fc!3m5!1s0x4871b10f0ef90449:0x11f6a7cca264e3da!8m2!3d51.832542!4d-2.61172!15sChtnbDE2IDdwQSBFTkdMSVNIIEJJQ0tOT1IgZmOSAQtzcG9ydHNfY2x1Yg",
    groundPhone: "07908 491558",
    badge: "../images/badges/EnglishBicknor.jpg",
    secretary: "Julie Howard",
    secretaryEmail:
      "mailto:julie.howard9?subject=Contact via the GCL web site",
    chairman: "Phillip Howard",
    programEditor: "Julie Howard",
    programEditorEmail:
      "mailto:julie.howard9?subject=Contact via the GCL web site",
    programHistory: "../downloads/English_Bicknor_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/English_Bicknor_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "https://www.englishbicknorfc.co.uk",
    socialWebText: "English Bicknor FC",
    socialTwitterHandle: "@bicknor_fc",
    socialTwitter: "https://twitter.com/bicknor_fc",
    socialFacebookHandle: "English Bicknor Football Club",
    socialFacebook: "https://www.facebook.com/englishbicknorfc/",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Black & Grey Shirts, White Shorts, White Socks",
    coloursHomeImage: "../images/shirts/english_bicknor_home_2021.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Red Shirts, White Shorts, White Socks",
    coloursAwayImage: "../images/shirts/english_bicknor_away_2021.jpg",
    teamImage: "",
    statsTeam: "English Bicknor",
  },
  {
    club: "Frampton United FC",
    id: "Frampton",
    ground: "The Bell Field, Bridge Road, Frampton on Severn, Glos GL2 7HA",
    groundHref:
      "https://maps.google.co.uk/maps?q=GL2+7HA&hl=en&ll=51.772856,-2.365633&spn=0.002669,0.006968&hnear=Frampton+on+Severn+GL2+7HA,+United+Kingdom&gl=uk&t=h&z=18",
    groundPhone: "07817 486933",
    badge: "../images/badges/frampton.png",
    secretary: "Sarah South",
    secretaryEmail:
      "mailto:framptonutdsec@gmail.com?subject=Contact via the GCL web site",
    chairman: "Richard Bull",
    programEditor: "Kevin Jackson",
    programEditorEmail:
      "mailto:kevjackson@aol.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Frampton_History.doc",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Frampton_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "../downloads/Frampton_Car.pdf",
    programCarIcon: "fas fa-file-pdf fa-2x",
    socialWeb: "https://www.pitchero.com/clubs/framptonunited",
    socialWebText: "Frampton United Football Club",
    socialTwitterHandle: "@FramptonFc",
    socialTwitter: "https://twitter.com/FramptonFc",
    socialFacebookHandle: "Frampton United Football",
    socialFacebook:
      "https://www.facebook.com/Frampton-United-Football-Club-114190726644041/",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Blue & White Shirts, Blue Shorts, Blue Socks",
    coloursHomeImage: "",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Red & Black Stripe Shirts, Red Shorts, Red Socks",
    coloursAwayImage: "",
    teamImage: "../images/teams/frampton_united_2020.jpg",
    statsTeam: "Frampton United",
  },
  {
    club: "Gala Wilton FC",
    id: "Gala",
    ground:
      "The Gala Club, Fairmile Gardens, Tewkesbury Road, Longford, Gloucester GL2 9EB",
    groundHref:
      "https://www.google.co.uk/maps/place/Longford,+Gloucester,+Gloucestershire+GL2+9EB/@51.8792658,-2.2343917,341m/data=!3m2!1e3!4b1!4m2!3m1!1s0x487106820764d90d:0xb31be756d1fe565dhttps://www.google.co.uk/maps/place/Longford,+Gloucester,+Gloucestershire+GL2+9EB/@51.8792658,-2.2343917,341m/data=!3m2!1e3!4b1!4m2!3m1!1s0x487106820764d90d:0xb31be756d1fe565d",
    groundPhone: "01452 524447",
    badge: "../images/badges/galawilton.png",
    secretary: "Lee Sheridan",
    secretaryEmail:
      "mailto:leesheridan@nhs.net?subject=Contact via the GCL web site",
    chairman: "Lee Sheridan",
    programEditor: "Lee Sheridan",
    programEditorEmail:
      "mailto:leesheridan@nhs.net?subject=Contact via the GCL web site",
    programHistory: "../downloads/Gala_History.doc",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Gala_Profile.doc",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "",
    socialWebText: "",
    socialTwitterHandle: "@GalaWiltonFC",
    socialTwitter: "https://twitter.com/GalaWiltonFC",
    socialFacebookHandle: "",
    socialFacebook: "",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Yellow & Black Shirts, Black Shorts, Yellow Socks",
    coloursHomeImage: "../images/shirts/gala_wilton_home_2020.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Pale Blue & White Shirts, White Shorts, Pale Blue Socks",
    coloursAwayImage: "../images/shirts/gala_wilton_away_2020.jpg",
    teamImage: "../images/teams/gala_wilton_2020.jpg",
    statsTeam: "Gala Wilton",
  },
  {
    club: "Hanham Athletic FC",
    id: "Hanham",
    ground:
      "Playing Fields Pavillion, 16 Vicarage Road, Hanham, Bristol, BS15 3AH",
    groundHref:
      "https://www.google.co.uk/maps/place/Vicarage+Rd,+Bristol+BS15+3AH/@51.4470431,-2.5272466,677m/data=!3m1!1e3!4m5!3m4!1s0x48718fa08ceddca3:0x142cbda1ef94ea8b!8m2!3d51.4470986!4d-2.5246803?hl=en",
    groundPhone: "0117 967 8291",
    badge: "../images/badges/hanham.png",
    secretary: "Bob Sperring",
    secretaryEmail:
      "mailto:bobsperring56@gmail.com?subject=Contact via the GCL web site",
    chairman: "Bob Sperring",
    programEditor: "Joanne Sperring",
    programEditorEmail:
      "mailto:conham@hotmail.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Hanham_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Hanham_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "",
    socialWebText: "",
    socialTwitterHandle: "@Hanham_Athletic",
    socialTwitter: "https://twitter.com/Hanham_Athletic",
    socialFacebookHandle: "Hanham Athletic Football Club",
    socialFacebook: "https://www.facebook.com/Hanham-Athletic-FC-1896-104366441103322",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Black & White Stripe Shirts, Black Shorts, Black Socks",
    coloursHomeImage: "../images/shirts/hanham_home_2020.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Yellow Shirts, Yellow Shorts, Yellow Socks",
    coloursAwayImage: "../images/shirts/hanham_away_2019.png",
    teamImage: "",
    statsTeam: "Hanham Athletic",
  },
  {
    club: "Hardwicke FC",
    id: "Hardwicke",
    ground:
      "Village Hall Playing Fields Green Lane, Hardwicke, Gloucester. GL2 4QA.",
    groundHref:
      "https://www.google.co.uk/maps/place/Hardwicke,+Gloucester+GL2+4QA/@51.8135787,-2.2895972,672m/data=!3m1!1e3!4m5!3m4!1s0x48710861546ab451:0xf62099ad28b28049!8m2!3d51.8140389!4d-2.2866801",
    groundPhone: "01452 540998",
    badge: "../images/badges/hardwicke.png",
    secretary: "Phillip Barnes",
    secretaryEmail:
      "mailto:secretary.hafc@hotmail.com?subject=Contact via the GCL web site",
    chairman: "Dareth Daly",
    programEditor: "Phillip Barnes",
    programEditorEmail:
      "mailto:secretary.hafc@hotmail.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Hardwicke_History.doc",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Hardwicke_Profile.doc",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "",
    socialWebText: "",
    socialTwitterHandle: "@HardwickeAFC",
    socialTwitter: "https://twitter.com/HardwickeAFC",
    socialFacebookHandle: "Hardwicke AFC",
    socialFacebook: "https://www.facebook.com/hardwickeafc",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Blue Shirts, Blue Shorts, Blue Socks",
    coloursHomeImage: "../images/shirts/hardwicke_home_2019.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Purple Shirts, White Shorts, Purple Socks",
    coloursAwayImage: "../images/shirts/hardwicke_away_2019.png",
    teamImage: "",
    statsTeam: "Hardwicke",
  },
  {
    club: "Henbury FC",
    id: "Henbury",
    ground: "Arnall Drive PF, Henbury, Bristol BS10 7AS.",
    groundHref:
      "https://www.google.co.uk/maps/place/Lorain+Walk,+Bristol+BS10+7AS/@51.5049258,-2.6261616,709m/data=!3m1!1e3!4m5!3m4!1s0x4871921517ac4281:0xf8080174447cca68!8m2!3d51.5049975!4d-2.6234343?hl=en",
    groundPhone: "0117 959 0475",
    badge: "../images/badges/henbury.png",
    secretary: "Jason Tarr",
    secretaryEmail:
      "mailto:jaymtee1969@gmail.com?subject=Contact via the GCL web site",
    chairman: "Trevor Richards",
    programEditor: "Raymond Bright",
    programEditorEmail:
      "mailto:raybright@hotmail.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Henbury_History.doc",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Henbury_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "http://www.henburyfc.uk/",
    socialWebText: "Henbury Football Club",
    socialTwitterHandle: "@HenburyFC",
    socialTwitter: "https://twitter.com/HenburyFC",
    socialFacebookHandle: "",
    socialFacebook: "",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Amber & Black Striped Shirts, Black Shorts, Black Socks",
    coloursHomeImage: "../images/shirts/henbury_home_2020.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Green & Black Striped Shirts, Green Shorts, Green Socks",
    coloursAwayImage: "../images/shirts/henbury_away_2020.jpg",
    teamImage: "",
    statsTeam: "Henbury",
  },
  {
    club: "Little Stoke FC",
    id: "Little",
    ground:
      "Little Stoke Park, Little Stoke Lane, Little Stoke, Bristol. BS34 6HR.",
    groundHref:
      "https://www.google.co.uk/maps/place/Little+Stoke+Ln,+Little+Stoke,+Bristol+BS34+6HR/@51.5272836,-2.5595187,709m/data=!3m1!1e3!4m5!3m4!1s0x487191aa48de4d85:0xa5173a1906b9971c!8m2!3d51.5271885!4d-2.5573856",
    groundPhone: "01454 865202",
    badge: "../images/badges/littlestoke.png",
    secretary: "Laura Coles",
    secretaryEmail:
      "mailto:lauraharris240@yahoo.co.uk?subject=Contact via the GCL web site",
    chairman: "Mike Harris",
    programEditor: "Jake Tovey",
    programEditorEmail:
      "mailto:jaketovey@outlook.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Little_Stoke_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Little_Stoke_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "",
    socialWebText: "",
    socialTwitterHandle: "@LittleStoke_FC",
    socialTwitter: "https://twitter.com/LittleStoke_FC",
    socialFacebookHandle: "Little Stoke Football Club",
    socialFacebook: "https://www.facebook.com/littlestokefc/",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome:
      "Black & White Stripe Shirts, Black Shorts, Black & White Socks",
    coloursHomeImage: "../images/shirts/little_stoke_home_2019.png",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Blue & White Shirts, Blue Shorts, White Socks",
    coloursAwayImage: "../images/shirts/little_stoke_away_2019.png",
    teamImage: "",
    statsTeam: "Little Stoke",
  },
  {
    club: "Patchway Town FC",
    id: "Patchway",
    ground: "Scott Park, Coniston Road, Patchway, Bristol BS34 5JR.",
    groundHref:
      "https://www.google.co.uk/maps/place/Coniston+Rd,+Patchway,+Bristol+BS34+5JR/@51.534297,-2.57211,1417m/data=!3m1!1e3!4m5!3m4!1s0x4871910c0c4e8d5b:0x17400c6bf031b142!8m2!3d51.5346903!4d-2.573567?hl=en",
    groundPhone: "0117 949 3952",
    badge: "../images/badges/patchway.png",
    secretary: "Richard Ashley",
    secretaryEmail:
      "mailto:richard-ashley@hotmail.co.uk?subject=Contact via the GCL web site",
    chairman: "Andrew England",
    programEditor: "Richard Ashley",
    programEditorEmail:
      "mailto:richard-ashley@hotmail.co.uk?subject=Contact via the GCL web site",
    programHistory: "../downloads/Patchway_History.doc",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Patchway_Town_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "https://www.theclubhq.com/patchway-town",
    socialWebText: "Patchway Town Football Club",
    socialTwitterHandle: "@patchwaytownfc",
    socialTwitter: "https://twitter.com/patchwaytownfc",
    socialFacebookHandle: "Patchway Town Football Club",
    socialFacebook: "https://www.facebook.com/patchwaytownfc/",
    socialInstaHandle: "patchwaytown",
    socialInsta: "https://www.instagram.com/patchwaytown/?hl=en",
    coloursHome: "Black & White Shirts, Black Shorts, Red Socks",
    coloursHomeImage: "../images/shirts/patchway_home_2021.jpg",
    coloursHomeImageBack: "../images/shirts/patchway_home_back_2021.jpg",
    coloursHomeImageKeep: "../images/shirts/patchway_home_keeper_2021.jpg",
    coloursHomeImageKeepBack: "../images/shirts/patchway_keeper_home_2021_back.jpg",
    coloursAway: "Red Shirts, White Shorts, White Socks",
    coloursAwayImage: "../images/shirts/patchway_away_2019.png",
    teamImage: "",
    statsTeam: "Patchway Town",
  },
  {
    club: "Quedgeley Wanderers FC",
    id: "Quedgeley",
    ground: "Waterwells Sports Centre, Stephenson Drive, Quedgeley, Gloucester, Gloucestershire, GL2 2AG",
    groundHref: "https://www.google.com/maps/place/Quedgeley+Wanderers+Football+Club/@51.8136546,-2.2686787,691m/data=!3m2!1e3!4b1!4m12!1m6!3m5!1s0x4871089269d08b49:0x487fa1ab153b02ee!2sWaterwells+Sports+Centre!8m2!3d51.8128539!4d-2.2667677!3m4!1s0x4871089240dca75d:0xfa0973f1dd477a0c!8m2!3d51.8136513!4d-2.2664903",
    groundPhone: "",
    badge: "../images/badges/quedgeley.png",
    secretary: "Kelly Mulrain",
    secretaryEmail:
      "mailto:kkamulrain@btinternet.com?subject=Contact via the GCL web site",
    chairman: "David Mulrain",
    programEditor: "Kelly Mulrain",
    programEditorEmail:
      "mailto:kkamulrain@btinternet.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Quedgeley_Wanderers_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Quedgeley_Wanderers_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "https://www.pitchero.com/clubs/quedgeleywanderers",
    socialWebText: "Quedgeley Wanderers Football Club",
    socialTwitterHandle: "@QWFC_",
    socialTwitter: "https://twitter.com/QWFC_",
    socialFacebookHandle: "",
    socialFacebook: "",
    socialInstaHandle: "quedgeleywanderers",
    socialInsta: "https://www.instagram.com/quedgeleywanderers/?hl=en",
    coloursHome: "Red & Black Shirts, Black Shorts, Black Socks",
    coloursHomeImage: "../images/shirts/quedgeley_home_2020.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Blue Shirts, Blue Shorts, Blue Socks",
    coloursAwayImage: "../images/shirts/quedgeley_away_2020.jpg",
    teamImage: "",
    statsTeam: "Quedgeley Wanderers",
  },
  {
    club: "Rockleaze Rangers FC",
    id: "Rockleaze",
    ground: "Hillside Gardens, Filton Road, Bristol, BS16 1QG",
    groundHref: "https://www.google.co.uk/maps/search/hillside+Gardens+bs16+1qg/@51.5034051,-2.5341099,661m/data=!3m1!1e3",
    groundPhone: "",
    badge: "../images/badges/rockleaze.png",
    secretary: "Toby Sharpe",
    secretaryEmail:
      "mailto:toby.sharpe@hotmail.co.uk?subject=Contact via the GCL web site",
    chairman: "Andrew Myland",
    programEditor: "Peter Bradbury",
    programEditorEmail:
      "mailto:bradburypeter@hotmail.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Rockleaze_Rangers_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Rockleaze_Rangers_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "http://www.rockleazerangers.org.uk",
    socialWebText: "Rockleaze Rangers Football Club",
    socialTwitterHandle: "@rockleaze",
    socialTwitter: "https://twitter.com/rockleaze",
    socialFacebookHandle: "",
    socialFacebook: "",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Red Shirts Black Trim, Black Shorts, Red & White Hooped Socks",
    coloursHomeImage: "../images/shirts/rockleaze_home_2019.png",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Sky Blue Shirts, White Shorts, Sky Blue Socks",
    coloursAwayImage: "../images/shirts/rockleaze_away_2019.png",
    teamImage: "",
    statsTeam: "Rockleaze Rangers",
  },
  {
    club: "Ruardean Hill Rangers FC",
    id: "Ruardean",
    ground: "Recreation Ground, Ruardean Hill, Drybrook, Glos, GL17 9AR",
    groundHref: "https://www.google.co.uk/maps/place/Ruardean+Hill+Sports+Club/@51.8476386,-2.5346852,1404m/data=!3m1!1e3!4m13!1m7!3m6!1s0x4871afdef2e8f90b:0x76065eb9df079d9c!2sRuardean+Hill,+Drybrook+GL17+9AR!3b1!8m2!3d51.8495343!4d-2.5282313!3m4!1s0x0:0xf2ea9208efe752b!8m2!3d51.8490114!4d-2.5314501",
    groundPhone: "01594 544871",
    badge: "../images/badges/ruardean.png",
    secretary: "Martin Coleman",
    secretaryEmail:
      "mailto:m.coleman78@btinternet.com?subject=Contact via the GCL web site",
    chairman: "Martin Coleman",
    programEditor: "Stuart Cornwell-Boote",
    programEditorEmail:
      "mailto:stueycb@icloud.com?subject=Contact via the GCL web site",
    programHistory: "../downloads/Ruardean_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Ruardean_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "https://www.ruardeanhillrangersfc.co.uk/",
    socialWebText: "Ruardean Hill Rangers Football Club",
    socialTwitterHandle: "@RHRFC",
    socialTwitter: "https://twitter.com/RHRFC",
    socialFacebookHandle: "Ruardean Hill Rangera Football Club",
    socialFacebook: "https://www.facebook.com/profile.php?id=100009735069839",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Light Blue & Navy Shirts, Navy Shorts, Navy Socks",
    coloursHomeImage: "../images/shirts/ruardean_home_2020.jpg",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Fluorescent Yellow and Black Shirts, Black Shorts, Yellow Socks",
    coloursAwayImage: "../images/shirts/ruardean_away_2020.jpg",
    teamImage: "",
    statsTeam: "Ruardean Hill Rangers",
  },
  {
    club: "Sharpness FC",
    id: "Sharpness",
    ground: "Hamfields, Berkeley, Gloucestershire, GL13 9TN",
    groundHref: "https://www.google.com/maps/place/Hamfields+Leisure/@51.6921915,-2.4917367,2772m/data=!3m1!1e3!4m13!1m7!3m6!1s0x4871a2e4e875bdbd:0x54f5d1943d9b4a89!2sHamfields,+Berkeley+GL13+9TN!3b1!8m2!3d51.692179!4d-2.4829819!3m4!1s0x4871a250fbc41faf:0xeb1078dceb3e82b8!8m2!3d51.6937883!4d-2.4890471",
    groundPhone: "",
    badge: "../images/badges/sharpness.png",
    secretary: "Tom Paterson",
    secretaryEmail:
      "mailto:shark4eva@hotmail.com?subject=Contact via the GCL web site",
    chairman: "Sam Paterson",
    programEditor: "Nick Grove",
    programEditorEmail:
      "mailto:grover-1@hotmail.co.uk?subject=Contact via the GCL web site",
    programHistory: "../downloads/Sharpness_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Sharpness_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "http://www.sharpnessafc.co.uk/",
    socialWebText: "Sharpness Football Club",
    socialTwitterHandle: "@sharpnessafc",
    socialTwitter: "https://twitter.com/sharpnessafc",
    socialFacebookHandle: "",
    socialFacebook: "",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Red Shirts, White Shorts, Red Socks",
    coloursHomeImage: "../images/shirts/sharpness_home_2019.png",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Sky Blue Shirts, Sky Blue Shorts, Sky Blue Socks",
    coloursAwayImage: "../images/shirts/sharpness_away_2019.png",
    teamImage: "",
    statsTeam: "Sharpness",
  },
  {
    club: "Shirehampton FC",
    id: "Shirehampton",
    ground: "Bristol Manor Farm, The Creek, Portway, Sea Mills, Bristol. BS9 2EJ",
    groundHref: "https://www.google.com/maps/place/Bristol+Manor+Farm+Football/@51.4819528,-2.6524479,696m/data=!3m2!1e3!4b1!4m5!3m4!1s0x48718d7e4dc17ca1:0x38798ceb785c8ef2!8m2!3d51.4820037!4d-2.6501538",
    groundPhone: "0117 968 3571",
    badge: "../images/badges/shirehampton.png",
    secretary: "Mark Stockham",
    secretaryEmail:
      "mailto:markstockham@yahoo.co.uk?subject=Contact via the GCL web site",
    chairman: "Peter McCall",
    programEditor: "Mark Stockham",
    programEditorEmail:
      "mailto:markstockham@yahoo.co.uk?subject=Contact via the GCL web site",
    programHistory: "",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Shirehampton_Profile.docx",
    programProfileIcon: "fas fa-file-word fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "",
    socialWebText: "",
    socialTwitterHandle: "@OfficialShireFC",
    socialTwitter: "https://twitter.com/OfficialShireFC",
    socialFacebookHandle: "Shirehampton Football Club",
    socialFacebook: "https://www.facebook.com/shirehamptonfc/",
    socialInstaHandle: "Shirehampton Football Club",
    socialInsta: "https://www.instagram.com/shirehampton.fc/?hl=en",
    coloursHome: "Red Shirts, Red Shorts, Red and Black Ringed Socks",
    coloursHomeImage: "",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Blue Shirts, Blue Shorts, Blue with Red Trim Socks",
    coloursAwayImage: "",
    teamImage: "",
    statsTeam: "Shirehampton",
  },
  {
    club: "Wick FC",
    id: "Wick",
    ground: "Oldbury Lane, Wick, Bristol BS30 5RJ",
    groundHref:
      "https://www.google.co.uk/maps/place/Wick+Football+Club/@51.4453843,-2.4263068,552m/data=!3m1!1e3!4m13!1m7!3m6!1s0x4871845e6018c8af:0x4f8a7141841e87d8!2sBristol+BS30+5RJ!3b1!8m2!3d51.4439762!4d-2.4254637!3m4!1s0x0:0x6f64a16d48e90a9f!8m2!3d51.4470513!4d-2.4221246",
    groundPhone: "07801 129560",
    badge: "../images/badges/wick.png",
    secretary: "Dave Beer",
    secretaryEmail:
      "mailto:wickfc@hotmail.co.uk?subject=Contact via the GCL web site",
    chairman: "John Towler",
    programEditor: "Matt Davis",
    programEditorEmail:
      "mailto:wickfc@hotmail.co.uk?subject=Contact via the GCL web site",
    programHistory: "../downloads/Wick_History.docx",
    programHistoryIcon: "fas fa-file-word fa-2x",
    programProfile: "../downloads/Wick_Profiles.xlsx",
    programProfileIcon: "fas fa-file-excel fa-2x",
    programCar: "",
    programCarIcon: "",
    socialWeb: "http://www.wickfc.org.uk",
    socialWebText: "Wick Football Club",
    socialTwitterHandle: "@wickowls",
    socialTwitter: "https://twitter.com/wickowls",
    socialFacebookHandle: "Wick Football",
    socialFacebook:
      "https://www.facebook.com/Wick-Football-Club-Bristol-644217548924299/",
    socialInstaHandle: "",
    socialInsta: "",
    coloursHome: "Orange with Black Trim Shirts, Black Shorts, Black Socks",
    coloursHomeImage: "",
    coloursHomeImageBack: "",
    coloursHomeImageKeep: "",
    coloursHomeImageKeepBack: "",
    coloursAway: "Yellow with Blue Trim Shirts, Yellow Shorts, Yellow Socks",
    coloursAwayImage: "../images/shirts/wick_away_2020.jpg",
    teamImage: "",
    statsTeam: "Wick",
  },
];